<template>
  <div class="page">
    <!-- 遮罩 -->
    <div class="mask"></div>

    <!-- 弹窗 -->
    <div class="popup" :style="{ marginTop: `${popup_top}px` }">
      <!-- 弹窗内容 -->

      <div class="popup-content" v-if="consumeList.length">
        <div class="popup-content-title">Consume List</div>

        <!-- 消耗记录列表 -->
        <div class="popup-content-list">
          <!-- 表格头 -->
          <div class="headTitle">
            <p class="headTitle-headstyle headTitle-user">Uses</p>
            <p class="headTitle-headstyle headTitle-amount">Amount</p>
            <p class="headTitle-headstyle headTitle-time">Time</p>
          </div>
          <!-- 记录 -->
          <div class="form">
            <div
              class="formItem"
              v-for="(item, index) in consumeList[currentPage - 1]"
              :key="index"
            >
              <p class="formItem-user">{{ CONSUME_USERS_TYPE[item.trading_channel] }}</p>
              <p class="formItem-amount">
                {{ item.arg_amount.replace("-", "") }}
              </p>
              <p class="formItem-time">
                {{ getTimeFormat(item.created_at * 1000, "YYYY/M/D") }}
              </p>
            </div>
          </div>
        </div>

        <!-- 翻页 -->
        <div class="operation">
          <div
            class="last"
            :class="{ middlePage: currentPage !== 1 }"
            @click="handleLast"
          ></div>
          <!-- 页码 -->
          <div class="pageNum">{{ `${currentPage}/${totalPage}` }}</div>
          <div
            class="next"
            :class="{ lastPage: currentPage === totalPage }"
            @click="handleDebounceNext"
          ></div>
        </div>
      </div>

      <!-- 缺省状态 -->
      <div class="popup-content empty" v-else>
        <img
          :src="
            require('@/assets/images/YuliApp/storageActivity/storageUpgrade/empty@2x.png')
          "
        />
        <div class="empty-text">No contents now</div>
      </div>

      <!-- 弹窗按钮 -->
      <div class="popup-btn" @click="handleClose"></div>
    </div>
  </div>
</template>

<script>
import { onMounted, ref } from "vue";
import hookStoreState from "@/utils/useState.js";
import { PRIZE_LIST } from "../../constants/storagePrize";
import { postGrowthRewardConfig } from "@/api/activity.js";
import { getTime, getUtcTime } from "@/utils/time.js";
import { CONSUME_USERS } from "../../constants/storagePrize.js";
export default {
  props: {
    consume_list: {
      type: Array,
      default: () => [],
    },
    consume_total: {
      type: Number,
      default: 0,
    },
  },
  watch: {
    consume_list: {
      handler(value) {
        console.log("二维数组", value);
        this.consumeList = value;
      },
      immediate: true,
      deep: true,
    },
    consume_total: {
      handler(value) {
        this.totalPage = Math.ceil(value / 10);
        if (!this.totalPage) {
          this.currentPage = 0;
        }
      },
      immediate: true,
      deep: true,
    },
  },

  computed: {},
  setup(props, { emit }) {
    const storeStateObj = hookStoreState({
      init: (state) => state.global.init,
      statusBarHeight: (state) => state.global.statusBarHeight,
    });

    const { statusBarHeight } = storeStateObj;
    const popup_top = ref(
      statusBarHeight.value + window.innerHeight * 0.1 - 20
    );
    const prize_list = ref([]);
    const consumeList = ref([]); //消耗记录
    const isCancelAll = ref(false);
    const isSelectAll = ref(false);

    const currentPage = ref(1); //当前页
    const totalPage = ref(1); //总页数
    const total = ref(0); //总记录数

    const getTimeFormat = ref(getUtcTime);

    const CONSUME_USERS_TYPE = ref(CONSUME_USERS)
    onMounted(() => {
      prize_list.value = PRIZE_LIST;
    });

    /**
     * 防抖
     */
    function debounce(fun, delay) {
      return function (args) {
        let that = this;
        let _args = args;
        clearTimeout(fun.id);
        fun.id = setTimeout(function () {
          fun.call(that, _args);
        }, delay);
      };
    }

    /**
     * 处理分页
     */
    const chunkPageInGroups = (consumeList, total) => {
      const twoArray = [];

      if (consumeList.length <= total) {
        twoArray.push(consumeList);
      }
      // console.log("二维数组", twoArray);
      consumeList.forEach((element) => {});

      return twoArray;
    };

    const handleDebounceNext = () => {
      //如果已经请求完数据则取消防抖
      if (
        consumeList.value.length === totalPage.value &&
        currentPage.value < totalPage.value
      ) {
        currentPage.value += 1;
        return;
      }
      debounce(handleNext, 400)();
    };

    /**
     * 下一页
     */
    const handleNext = () => {
      // 如果当前页到了最后一页
      if (currentPage.value === totalPage.value) {
        return;
      }

      //如果下一页数据已经请求过
      if (
        consumeList.value[currentPage.value] &&
        consumeList.value[currentPage.value].length > 0
      ) {
        currentPage.value += 1;
        return;
      }
      emit("handleNext", currentPage + 1);
      currentPage.value += 1;
    };

    /**
     * 上一页
     */
    const handleLast = () => {
      if (currentPage.value === 1) {
        return;
      }
      currentPage.value -= 1;
    };

    /**
     * 处理关闭
     */
    const handleClose = () => {
      emit("close", false);
    };

    return {
      popup_top,
      handleClose,
      prize_list,
      handleLast,
      handleNext,
      isSelectAll,
      isCancelAll,
      consumeList,
      chunkPageInGroups,
      getTimeFormat,
      currentPage,
      totalPage,
      total,
      debounce,
      handleDebounceNext,
      CONSUME_USERS_TYPE
    };
  },
};
</script>

<style lang="less" scoped>
p {
  margin: 0;
  padding: 0;
}
.page {
  width: 100%;
  height: 100%;
  margin-top: -60px;
  overflow: hidden;
  position: absolute;
  bottom: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  z-index: 999;

  .mask {
    position: absolute;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.7);
    top: 0;
    left: 0;
  }

  .popup {
    width: 351px;
    // margin-top: 128px; // 84
    position: relative;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;

    &-content {
      box-sizing: border-box;
      width: 375px;
      height: 720px;
      background-image: url("~@/assets/images/YuliApp/storageActivity/storageUpgrade/bg_record@2x.png");
      background-size: 100% 100%;
      padding-top: 62px;
      &-title {
        margin: 0 auto 21.71px auto;
        width: 231px;
        height: 59px;
        background-image: url("~@/assets/images/YuliApp/storageActivity/storageUpgrade/bg_pog_title@2x.png");
        background-size: 100% 100%;

        color: rgba(114, 117, 137, 1);
        font-size: 23.14px;
        font-weight: 700;
        font-family: "PingFang SC";
        text-align: center;
        line-height: 64px;
        white-space: nowrap;
      }
      &-list {
        display: flex;
        flex-direction: column;
        align-items: center;
        .headTitle {
          display: flex;
          align-items: center;
          width: 318px;
          height: 44px;
          background-image: url("~@/assets/images/YuliApp/storageActivity/storageUpgrade/biaoge_tou@2x.png");
          background-size: 100% 100%;
          &-headstyle {
            color: rgba(215, 216, 224, 1);
            font-size: 15px;
            font-weight: 700;
            font-family: "PingFang SC";
            text-align: center;
            line-height: 44px;
            white-space: nowrap;
          }
          &-user {
            width: 128px;
          }
          &-amount {
            width: 88px;
          }
          &-time {
            width: 104px;
          }
        }
        .form {
          display: flex;
          flex-direction: column;
          align-items: center;
          width: 100%;
        }

        .formItem {
          display: flex;
          align-items: center;
          width: 318px;
          height: 44px;
          background-image: url("~@/assets/images/YuliApp/storageActivity/storageUpgrade/biaoge_gezi@2x.png");
          background-size: 100% 100%;
          margin-top: -1px;

          font-size: 15px;
          font-size: 14.79px;
          font-weight: 700;
          font-family: "PingFang SC";
          text-align: center;
          line-height: 44px;
          white-space: nowrap;
          &-user {
            width: 128px;
            color: rgba(45, 120, 102, 1);
          }
          &-amount {
            width: 88px;
            color: rgba(78, 83, 102, 1);
          }
          &-time {
            width: 104px;
            color: rgba(78, 83, 102, 1);
          }
        }
      }

      .operation {
        position: absolute;
        left: 50%;
        bottom: 39px;
        transform: translate(-50%, 0);

        width: 258px;
        display: flex;
        align-items: center;
        justify-content: space-around;
        .last,
        .next {
          width: 72px;
          height: 33.31px;
          img {
            width: 100%;
            height: 100%;
          }
        }
        .last {
          background-image: url("~@/assets/images/YuliApp/storageActivity/storageUpgrade/button_left@2x.png");
          background-size: 100% 100%;
        }
        .next {
          background-image: url("~@/assets/images/YuliApp/storageActivity/storageUpgrade/button_right@2x.png");
          background-size: 100% 100%;
        }
        .middlePage {
          background-image: url("~@/assets/images/YuliApp/storageActivity/storageUpgrade/button_right@2x.png");
          background-size: 100% 100%;
          transform: rotate(-180deg);
        }
        .lastPage {
          opacity: 0.5;
        }
        .pageNum {
          color: rgba(231, 231, 237, 1);
          font-size: 14px;
          font-weight: 700;
          font-family: "PingFang SC";
          text-align: center;
          line-height: 16.8px;
          letter-spacing: 1.12px;

          text-stroke: 1px #6a6d83;
          /* 兼容Webkit(Chrome/Safari)内核浏览器的写法 */
          -webkit-text-stroke: 1px #6a6d83;
        }
      }
    }
    .empty {
      padding-top: 250px;
      &-text {
        color: rgba(137, 140, 154, 1);
        font-size: 16px;
        font-weight: 500;
        font-family: "PingFang SC";
        text-align: center;
        line-height: 22px;
      }
      img {
        width: 130px;
        height: 130px;
        margin-bottom: 10px;
      }
    }
    &-btn {
      // margin-top: 28px;
      position: absolute;
      z-index: 999;
      top: 0px;
      right: 23px;
      width: 46.04px;
      height: 46px;
      img {
        width: 100%;
        height: 100%;
      }
    }
  }
}
@media screen and (max-height: 730px) {
  .page {
    .popup {
      height: 100%;
      margin-top: 25px !important;
      &-content {
        height: 97%;
        &-list {
          height: 65.83%;
          .form {
            overflow-y: scroll;
            -webkit-overflow-scrolling: touch;
          }
          //隐藏滚动条
          .form::-webkit-scrollbar {
            display: none;
          }
          .form {
            scrollbar-width: none;
            -ms-overflow-style: none;
            overflow-y: scroll;
            overflow-x: hidden;
          }
        }
      }
      .empty {
        padding-top: 200px;
      }
    }
  }
}
@media screen and (max-height: 670px) {
  .page {
    .popup {
      margin-top: 25px !important;
      &-btn {
        position: absolute;
        z-index: 999;
        bottom: -24px;
        width: 40px;
        height: 40px;
      }
    }
  }
}
</style>
